// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';


import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import SelectAllIcon from '@material-ui/icons/SelectAll';


import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import { ACTIVITY_PAGES } from 'constants/activity.constants';

const styles = theme => ({
  root : {
  },
  selectAllCheck : {
    color: 'white',
    marginLeft: 20,
    paddingTop: 2,
    paddingBottom: 2,
  },
  checkBox : {
    paddingLeft: 30,
    '& .MuiCheckbox-root' : {
      paddingTop: 2,
      paddingBottom: 2,
      color: '#000',
    }
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiCore.Slide direction="left" ref={ref} {...props} />;
});


/*
 * Modify filters
 */

class FilterDialog extends Component {
  state = {
    editFilters: [],
    open : false,
    initFilters: []
  }

  /*
   * Make an edit copy of the filters whenever transitioning to open
   */
  componentDidUpdate() {
    if(this.state.initFilters.length === 0){
      this.setState({
        initFilters: JSON.parse(
          JSON.stringify(
              this.props.allFilters[this.props.type ?? ACTIVITY_PAGES.ACTIVITY]
          )
        ),
      });
    }
    if (!this.state.open && this.props.showFilterDialog) {
      this.setState({open: true, editFilters: {...this.props.allFilters[this.props.type ?? ACTIVITY_PAGES.ACTIVITY]}});
    }
    if (this.state.open && !this.props.showFilterDialog) {
      this.setState({open: false});
    }
  }

  clearAll = () => {
    let editFilters = { ...this.state.editFilters };
    Object.keys(editFilters).forEach(key => {
      editFilters[key].active = false;
    });
    this.setState({editFilters});    
  }

  toggleOne = (key) => {
    let editFilters = { ...this.state.editFilters };
    editFilters[key].active = !editFilters[key].active;
    this.setState({editFilters});    
  }

  applyFilters = () => {
    this.props.updateFilters(this.state.editFilters, this.props.type ??  ACTIVITY_PAGES.ACTIVITY);
    this.setState({initFilters: []});
    this.props.setShowFilterDialog(false);
  }

  render() {
    // eslint-disable-next-line    
    const { classes } = this.props;
    const { editFilters } = this.state;
    return(
      <React.Fragment>
        <MuiCore.Dialog open={this.state.open}
                        onClose={() => {
                          this.props.updateFilters(this.state.initFilters, this.props.type ??  ACTIVITY_PAGES.ACTIVITY);
                          this.setState({initFilters: []});
                          this.props.setShowFilterDialog(false)
                        }}
                        maxWidth="sm"
                        TransitionComponent={Transition}>
          <MuiCore.DialogTitle><MuiCore.Typography style={{fontFamily: 'Sofia-bold', color: '#000'}}>Filters</MuiCore.Typography></MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.Grid container direction='column'
                          spacing={0}
                          alignItems='flex-start'>
              <MuiCore.Grid item>
                <MuiCore.Grid item>
                  <MuiCore.FormControlLabel style={{fontFamily: 'Sofia', color: '#000'}} className={classes.checkBox}
                    control={
                      <MuiCore.Checkbox
                        onClick={this.clearAll}
                        checked={false} 
                        icon={<SelectAllIcon/>}
                      />
                    }
                                            label={<MuiCore.Typography style={{fontFamily: 'Sofia', color: '#000'}}>Clear Filters</MuiCore.Typography>}/>
                </MuiCore.Grid>                  
              </MuiCore.Grid>
                
              {Object.keys(editFilters).map(filterKey=>(
                <MuiCore.Grid item key={filterKey}>
                  <MuiCore.FormControlLabel className={classes.checkBox}
                                            label={<MuiCore.Typography style={{fontFamily: 'Sofia', color: '#000'}}>{editFilters[filterKey].label}</MuiCore.Typography>}
                                            // label={editFilters[filterKey].label}
                  control={
                    <MuiCore.Checkbox
                      onClick={() => this.toggleOne(filterKey)}
                      checked={editFilters[filterKey].active}
                      value={filterKey}
                    />
                  }/>
                </MuiCore.Grid>
              ))}
            </MuiCore.Grid>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 40, paddingRight: 40, fontFamily: 'Sofia'}}>
            <MuiCore.Button onClick={this.applyFilters} style={{fontFamily: 'Sofia', fontWeight: 700}}>
              Apply filters
            </MuiCore.Button>
            <MuiCore.Button
              style={{fontFamily: 'Sofia', color: '#000'}}
              onClick={() => {
                this.props.updateFilters(this.state.initFilters, this.props.type ??  ACTIVITY_PAGES.ACTIVITY);
                this.setState({initFilters: []});
                this.props.setShowFilterDialog(false)
              }}
              variant='text'>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
      </React.Fragment>);
    
  }
}

const mapStateToProps = (state) => {
  return ({
    allFilters: serviceSelectors.getAllFilters(state),
    showFilterDialog : serviceSelectors.getShowFilterDialog(state),
  });
};

const mapDispatchToProps = {
  updateFilters : serviceActions.updateFilters,
  setShowFilterDialog : serviceActions.setShowFilterDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FilterDialog));

